import React, { forwardRef } from 'react';
import { animated } from 'react-spring';
import { uid } from 'react-uid';
import Tag from '../../Tag';
import SendGridLink from '../../SendGridLink';
import LinkList from '../LinkList';
import IconLinkList from '../IconLinkList';
import FeaturedCustomers from '../FeaturedCustomers';
import LinkWithTextList from '../LinkWithTextList';
import CalloutList from '../CalloutList';
import ContactUsBlock from '../ContactUsBlock';
import { StyledSubMenu, StyledSubMenuGrid, StyledBanner } from './styles';

const AnimatedSubMenu = animated(StyledSubMenu);
const AnimatedSubMenuGrid = animated(StyledSubMenuGrid);
const AnimatedBanner = animated(StyledBanner);

const SubMenu = ({ isOpen, blocks, banner, spring, label, navigationState, setNavigationState }, ref) => {
  const { opacity, visibility, transform } = spring;
  return (
    <AnimatedSubMenu ref={ref} isOpen={isOpen} style={{ visibility }}>
      <AnimatedSubMenuGrid style={{ opacity, transform }}>
        {blocks.map(({ fieldGroupName, ...menuProps }, i, blocks) => {
          let isLastBlock = (i + 1 === blocks.length) ? true : false;
          switch (fieldGroupName.split('_').pop()) {
            case 'LinkList':
              return <LinkList 
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            case 'IconLinkList':
              return <IconLinkList
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            case 'FeaturedCustomers':
              return <FeaturedCustomers
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            case 'LinkWithTextList':
              return <LinkWithTextList
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            case 'CalloutList':
              return <CalloutList
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            case 'blocks':
              return <ContactUsBlock
                key={uid(menuProps)}
                isLastBlock={isLastBlock}
                label={label}
                navigationState={navigationState}
                setNavigationState={setNavigationState}
                {...menuProps} />;
            default:
              return null;
          }
        })}
      </AnimatedSubMenuGrid>
      {banner && (
        <AnimatedBanner style={{ opacity }}>
          {banner.badge && (
            <Tag dangerouslySetInnerHTML={{ __html: banner.badge }} />
          )}
          <p dangerouslySetInnerHTML={{ __html: banner.title }} />
          <p>
            <SendGridLink
              className="arrow-link"
              to={banner.ctaUrl}
              dangerouslySetInnerHTML={{ __html: banner.ctaText }}
            />
          </p>
        </AnimatedBanner>
      )}
    </AnimatedSubMenu>
  );
};
export default forwardRef(SubMenu);
